export default __webpack_public_path__ + "static/media/fever.05bb522c.png";